import React from 'react'

const IconStar: React.FunctionComponent = () => {
  return <>
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12">
      <path d="M10.12 1.171 6.987 5.457l5.107-.686v2.343l-5.201-.571 3.133 4.114-2.13 1.257-1.912-4.743L3.728 12l-1.942-1.229 3.133-4.2-4.919.6V4.83l4.982.657-3.196-4.257L3.854 0l2.099 4.8L8.083 0l2.037 1.171Z" fill="#FFD100" />
    </svg>
  </>
}

export default IconStar